/* eslint-disable @typescript-eslint/no-unused-vars */

import { RowData } from "@tanstack/react-table";
import {
  functionalUpdate,
  makeStateUpdater,
  OnChangeFn,
  Table,
  TableFeature,
  Updater,
} from "@tanstack/table-core";

export type AllSelectedState = boolean;

export interface AllSelectedTableState {
  allSelected?: AllSelectedState;
}

// define types for our new feature's table options
export interface AllSelectedOptions {
  onAllSelectedChange?: OnChangeFn<AllSelectedState>;
}

// Define types for our new feature's table APIs
export interface AllSelectedInstance {
  setAllSelected: (updater: Updater<AllSelectedState>) => void;
  getAllSelected: () => boolean;
  // isAllSelected(): boolean;
}

// export interface GalleryColumnDef {
//   box?: {
//     hidden?: boolean;
//     props?: React.DetailedHTMLProps<
//       React.HTMLAttributes<HTMLDivElement>,
//       HTMLDivElement
//     > &
//       any;
//   };
// }

// Use declaration merging to add our new feature APIs and state types to TanStack Table's existing types.
declare module "@tanstack/react-table" {
  //merge our new feature's state with the existing table state
  interface TableState extends AllSelectedTableState {}
  //merge our new feature's options with the existing table options
  interface TableOptionsResolved<TData extends RowData>
    extends AllSelectedOptions {}
  //merge our new feature's instance APIs with the existing table instance APIs
  interface Table<TData extends RowData> extends AllSelectedInstance {}
  // if you need to add header instance APIs...
  // interface Header<TData extends RowData, TValue> extends GalleryHeader
}

// end of TS setup!

// Here is all of the actual javascript code for our new feature
export const AllSelectedFeature: TableFeature<any> = {
  // define the new feature's initial state
  getInitialState: (state): AllSelectedTableState => {
    return {
      allSelected: undefined,
      ...state,
    };
  },

  // define the new feature's default options
  getDefaultOptions: <TData extends RowData>(
    table: Table<TData>,
  ): AllSelectedOptions => {
    return {
      onAllSelectedChange: makeStateUpdater("allSelected", table),
    } as AllSelectedOptions;
  },
  // if you need to add a default column definition...
  // getDefaultColumnDef: <TData extends RowData>(): Partial<ColumnDef<TData>> => {
  //   return { meta: {} } //use meta instead of directly adding to the columnDef to avoid typescript stuff that's hard to workaround
  // },

  // define the new feature's table instance methods
  createTable: <TData extends RowData>(table: Table<TData>): void => {
    table.setAllSelected = (updater) => {
      return table.options.onAllSelectedChange?.((old) => {
        const next = functionalUpdate(updater, old);
        return next;
      });
    };
    table.getAllSelected = () => !!table.getState().allSelected;
    // table.getIsAllRowsSelected = () => !!table.getState().allSelected; //  || getIsAllRowsSelected()
    // const getIsAllPageRowsSelected = table.getIsAllPageRowsSelected;
    // table.getIsAllPageRowsSelected = () =>
    //   table.getState().allSelected || getIsAllPageRowsSelected();
    // table.toggleAllRowsSelected = (value?: boolean) =>
    //   table.setAllSelected(!!value);
    // const getIsSomePageRowsSelected = table.getIsSomePageRowsSelected;
    // table.getIsSomePageRowsSelected = () =>
    //   table.getState().allSelected || getIsSomePageRowsSelected();
  },

  // if you need to add row instance APIs...
  // createRow: <TData extends RowData>(row: Row<TData>, table: Table<TData>): void => {},
  // if you need to add cell instance APIs...
  // createCell: <TData extends RowData>(cell, column, row, table): void => {},
  // if you need to add column instance APIs...
  //   createColumn: <TData extends RowData>(column: Column<TData>, table: Table<TData>): void => {},
  // if you need to add header instance APIs...
  // createHeader: <TData extends RowData>(header, table): void => {},
};
//end of custom feature code
